import classNames from 'clsx'
import { forwardRef } from 'react'

import S from './Input.module.scss'

export interface InputProps extends React.ComponentPropsWithoutRef<'input'> {
  fullWidth?: boolean
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, fullWidth = false, ...props }, ref) => {
    return (
      <input
        {...props}
        ref={ref}
        className={classNames(S.input, fullWidth && S.fullWidth, className)}
      />
    )
  }
)

Input.displayName = 'Input'

export default Input
